import { PlaybackBtn } from '@mi-front/ui';
import { Box } from '@mui/material';

interface ChunkActionsProps {
  /** Start/restart chunk playback */
  onPlay: () => void;
}

/**
 * Presentational component for chunk playback controls.
 * Play button always restarts playback from chunk beginning.
 */
export function ChunkActions({ onPlay }: ChunkActionsProps) {
  return (
    <Box sx={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>
      <PlaybackBtn data-testid="playback-btn" size="large" isPlaying={false} onClick={onPlay} />
    </Box>
  );
}
